import React, { Component } from 'react';

import getNLS from '../common/_NLS';

export default props=>{

  const jsx = <div className="this-content" >

    <style jsx>{`
  * {
    box-sizing: border-box;
    margin:0;
    border:0;
    padding:0;
  }

.this-content{
  width: 100%;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;

  margin: 0 auto;
  // border: solid;
  background-color: #ffffff;

}

.display-inline{
  display: inline-block;
  margin: 0;
  vertical-align: middle;
  
}

.highlightable{
    height: 45px;
    border-bottom: solid 2px;
    border-color: #adb5bd;
    color: #adb5bd;
    width: 49%;
    box-sizing: border-box;
    text-align: center;

    /* 0425 크롬디폴트(=퍼블리싱기준=16px) 에 맞춤 */
    font-family: NotoSansCJKkr;
    /* font-size: 16px; */

    font-size: 18px;

}

.highlighted{
  color: black;

  border-color: black;
}

.generalfont{

}

`}</style>

    <div className={`display-inline highlightable ${props.isMagazine ? "highlighted" : ""}`} onClick={() => location.href = "/magazine/list"}>{getNLS("매거진")}</div>
    &nbsp;
    <div className={`display-inline highlightable ${props.isCommunity ? "highlighted" : ""}`} onClick={() => location.href = "/community/list"}>{getNLS("커뮤니티")}</div>

  </div>;


  return (jsx);
}
